// extracted by mini-css-extract-plugin
export var col = "styles-module--col--fc5b6";
export var colContent = "styles-module--colContent--f2c41";
export var colDark = "styles-module--colDark--693bb";
export var title = "styles-module--title--5fd13";
export var twoCols = "styles-module--twoCols--9d4f5";
export var visible = "styles-module--visible--2ca84";